<template>
  <div>
    <!-- -->
    <div style="width: 100%" id="editorElem-resource" ref="editor"></div>
  </div>
</template>

<script>
import E from "wangeditor";
import { fileUp, fileEcho } from "@/api/url";
export default {
  props: {
    isDisabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: "",
    },
  },
  watch: {
    value(val) {
      this.editor.txt.html(val);
    },
  },
  data() {
    return {
      html: "",
      editor: null, //副文本
      editorId: "", //富文本id
      fileUp: fileUp,
      fileEcho: fileEcho,
    };
  },
  mounted() {
    this.editor = new E("#editorElem-resource");
    this.editor.config.menus = [
      "head",
      "bold",
      "fontSize",
      "fontName",
      "italic",
      "underline",
      "strikeThrough",
      "indent",
      "lineHeight",
      "foreColor",
      "backColor",
      "link",
      "list",
      "justify",
      "quote",
      "emoticon",
      "image",
      "table",
      "code",
      "splitLine",
      "undo",
      "redo",
    ];
    this.editor.config.uploadImgServer =
      this.fileUp + "?keepActive=true&originalProxy=fullText"; //'http://192.168.0.107:8082/app/files/richTextUpload';//this.fileUp;  // 上传图片到服务器
    // this.editor.config.uploadImgShowBase64 = true;   // 使用 base64 保存图片
    this.editor.config.uploadImgAccept = ["jpg", "jpeg", "png", "gif", "bmp"];
    this.editor.config.debug = true; // 开启debug模式
    this.editor.config.uploadImgHeaders = {
      Authorization: "Bearer " + sessionStorage.getItem("token"),
    };
    // 3M
    this.editor.config.uploadImgMaxSize = 3 * 1024 * 1024;
    // 限制一次最多上传 1 张图片
    this.editor.config.uploadImgMaxLength = 10;
    // 上传文件参数
    this.editor.config.uploadFileName = "file";
    // 将 timeout 时间改为 5s
    this.editor.config.uploadImgTimeout = 15000;

    this.editor.txt.html(this.value);
    console.log(this.editor.config.onchange);
    this.editor.config.onchange = (newHtml) => {
      this.html = newHtml;
      this.$emit("update:value", newHtml);
    };
    // 配置触发 onchange 的时间频率，默认为 200ms
    this.editor.config.onchangeTimeout = 500; // 修改为 500ms
    this.editor.config.uploadImgHooks = {
      before: function(xhr, editor, files) {
        // 图片上传之前触发
        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，files 是选择的图片文件
        // 如果返回的结果是 {prevent: true, msg: 'xxxx'} 则表示用户放弃上传
        // return {
        //     prevent: true,
        //     msg: '放弃上传'
        // }
        // alert("前奏");
      },
      success: function(xhr, editor, result) {
        // 图片上传并返回结果，图片插入成功之后触发
        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
        // var url = result.data.url;
        // alert(JSON.stringify(url));
        // editor.txt.append(url);
        // alert("成功");
      },
      fail: function(xhr, editor, result) {
        // 图片上传并返回结果，但图片插入错误时触发
        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
      },
      error: function(xhr, editor) {
        // 图片上传出错时触发
        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
        // alert("错误");
      },
      // 如果服务器端返回的不是 {errno:0, data: [...]} 这种格式，可使用该配置
      // （但是，服务器端返回的必须是一个 JSON 格式字符串！！！否则会报错）
      customInsert: function(insertImg, result, editor) {
        // 图片上传并返回结果，自定义插入图片的事件（而不是编辑器自动插入图片！！！）
        // insertImg 是插入图片的函数，editor 是编辑器对象，result 是服务器端返回的结果
        // 举例：假如上传图片成功后，服务器端返回的是 {url:'....'} 这种格式，即可这样插入图片：
        insertImg(fileEcho + result.watermark);
        // result 必须是一个 JSON 格式字符串！！！否则报错
      },
    };
    this.editor.create(); //创建实例
    this.isDisabled && this.editor.disable();
  },
  methods: {},
};
</script>
<style>
.w-e-text-container {
  z-index: 100 !important;
}
.w-e-toolbar {
  z-index: 101 !important;
}
</style>
